var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInfTwitter(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 96.645,
    height: 78.203,
    viewBox: "0 0 96.645 78.203",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "iconfinder_03-twitter_104501_1_",
    "data-name": "iconfinder_03-twitter_104501 (1)",
    d: "M98.574,19.465a38.781,38.781,0,0,1-11.195,3.068,19.525,19.525,0,0,0,8.57-10.784,39.015,39.015,0,0,1-12.377,4.732A19.506,19.506,0,0,0,50.363,34.258,55.339,55.339,0,0,1,10.189,13.894a19.515,19.515,0,0,0,6.032,26.022,19.435,19.435,0,0,1-8.828-2.439c0,.081,0,.164,0,.247A19.506,19.506,0,0,0,23.026,56.834a19.6,19.6,0,0,1-5.135.683,19.311,19.311,0,0,1-3.668-.351A19.512,19.512,0,0,0,32.429,70.7a39.329,39.329,0,0,1-28.855,8.07,55.154,55.154,0,0,0,29.877,8.757c35.851,0,55.454-29.7,55.454-55.454q0-1.267-.054-2.524A39.475,39.475,0,0,0,98.574,19.465Z",
    transform: "translate(-3.304 -9.826)",
    fill: "rgba(93,169,221,0.2)",
    stroke: "#5da9dd",
    strokeWidth: 1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfTwitter);
export default __webpack_public_path__ + "static/media/infTwitter.2ea97bcb722fded08900b568ddc6823b.svg";
export { ForwardRef as ReactComponent };